/** Infra API del módulo Promociones — repos y queries.
 * Importar desde acá para evitar require cycles cuando se necesita solo infra. */

export {
  listPromotionsCache,
  getPromotionByIdCache,
  createPromotionIntake,
  updatePromotionIntake,
  deletePromotionIntake,
} from './infra/promotionsRepo';

export {
  getPromotionHistory,
  getPromotionHistoryCount,
  getPromotionEventTypeLabel,
  type PromotionEventRow,
  type PromotionEventType,
  type PromotionHistoryFilters,
} from './infra/promotionEventQueries';

export {
  fetchPromotionUsageCounts,
  promotionIdsNeedingUsageCount,
} from './infra/promotionUsageCounts';
